import { BaseConverter } from '../../base/converters/base-converter.converter';
import { RoleModel } from '../models/role.model';
import { Role } from '../DTO/role';
import { Injectable } from '@angular/core';

@Injectable()
export class RoleConverter extends BaseConverter<RoleModel, Role> {

  public convertToModel(dto: Role): RoleModel {

    if (!dto) {
      return;
    }
    let model: RoleModel = new RoleModel(
      dto.active,
      dto.description,
      dto.validFrom,
      dto.validUntil);
    model.id = dto.id;
    return model;

  }
  public convertToDto(model: RoleModel): Role {

    if (!model) {
      return;
    }

    return {
      id: model.id,
      active: model.active,
      description: model.description,
      validFrom: model.validFrom,
      validUntil: model.validUntil
    }
  }

}